import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import Grid from "@material-ui/core/Grid";
import styles from "./ModifyReservationPrice.module.scss";
import ReportProblemOutlinedIcon from "@material-ui/icons/ReportProblemOutlined";
import CheckBox from "../../../../../shared/checkBox/CheckBox";
import { TextValidator } from "react-material-ui-form-validator";
class ReservationList extends Component {
  displayPrice = (item) => {
    if (
      item.amount !== null &&
      (!!item.amount || item.amount >= 0) &&
      item.amount !== false
    ) {
      return (
        <div>
          {this.props.defaultCurrencySymbol}{" "}
          {parseFloat(item.amount).toFixed(2)}
        </div>
      );
    }
  };

  render() {
    return this.props.reservations.map((res, idx) => (
      <Grid
        container
        key={res.model}
        className={`${styles.row} ${res.newVehicleLine && styles.nvlRow} ${
          res.checked && styles.checkedRow
        }`}
      >
        {res.newVehicleLine && (
          <ReportProblemOutlinedIcon className={styles.warningIcon} />
        )}
        <Grid item md={8} className={styles.gridItem}>
          <CheckBox
            id={`checkbox${idx}`}
            value={idx}
            isDisabled={!this.props.userCanEdit}
            checked={res.checked}
            onChange={this.props.checkItem}
          />{" "}
          {res.model}
        </Grid>
        <Grid item md={4} className={styles.gridItemRight}>
          {this.props.editMode ? (
            <TextValidator
              autoComplete="off"
              name={res.model}
              variant="outlined"
              value={this.props.hasAmount(res.amount) ? res.amount : ""}
              onChange={(e) => this.props.updateReservation(e, idx)}
              validators={[
                "minNumber:0",
                "maxNumber:2000000000",
                "isNumber",
                "isNumericWithTwoDecimalPlaces",
              ]}
              errorMessages={[
                this.props.t("Error.invalidInput"),
                this.props.t("Error.invalidInput"),
                this.props.t("Error.invalidInput"),
                this.props.t("Error.invalidInput"),
              ]}
            />
          ) : (
            this.displayPrice(res)
          )}
        </Grid>
      </Grid>
    ));
  }
}

export default withTranslation("emp")(ReservationList);
